<template>
    <div
        data-component="MsItemSlider"
        class="relative -mx-16 -mb-16"
    >
        <component
            :is="listTag"
            ref="scrollableElement"
            :role="listRole"
            class="flex px-16 pb-16 [&>*]:flex-shrink-0 overflow-scroll scrollbar-hide gap-24"
        >
            <slot />
        </component>
        <transition
            enter-to-class="opacity-100"
            enter-from-class="opacity-0"
            leave-to-class="opacity-0"
            leave-from-class="opacity-100"
        >
            <button
                v-if="isPrevButtonVisible"
                class="left-16 z-expanding-nav -translate-x-1/2 absolute p-8 top-1/2 -translate-y-1/2 rounded-full bg-color-greyscale-black transition duration-300 bg-opacity-50 hover:bg-opacity-100"
                type="button"
                aria-label="previous"
                @click="onPrevClick"
            >
                <MsChevron class="w-24 h-24 text-white rotate-90" />
            </button>
        </transition>
        <transition
            enter-to-class="opacity-100"
            enter-from-class="opacity-0"
            leave-to-class="opacity-0"
            leave-from-class="opacity-100"
            :duration="500"
        >
            <button
                v-if="isNextButtonVisible"
                class="right-20 z-expanding-nav translate-x-1/2 absolute p-8 top-1/2 -translate-y-1/2 rounded-full bg-color-greyscale-black transition duration-300 bg-opacity-50 hover:bg-opacity-100"
                type="button"
                aria-label="next"
                @click="onNextClick"
            >
                <MsChevron class="w-24 h-24 text-white -rotate-90" />
            </button>
        </transition>
    </div>
</template>
<script lang="ts" src="./MsItemSlider.ts"></script>
